import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
//import { debounceTime, Subject } from 'rxjs';


import { SharedUtilsService } from 'src/app/core/services/shared-utils.service';

@Component({
  selector: 'app-adresseslistepopup',
  templateUrl: './adresseslistepopup.component.html',
  styleUrls: ['./adresseslistepopup.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdressesListepopupComponent implements OnInit {
  
  
    address: string = '';
    latitude: number = 0.0;
    longitude: number= 0.0;
  
    adressSelected: boolean = false;
    private ignorerProchaineRecherche = false;
  

  constructor(@Inject(MAT_DIALOG_DATA) public data: any
  , public sharedUtilsService: SharedUtilsService
  , private http: HttpClient
  , public dialogRef: MatDialogRef<AdressesListepopupComponent>
) {
 }


   ngOnInit(): void {

      this.adressSelected = false;
      this.address = '';
   }



  selectSuggestion(suggestion: any) {
    if (!suggestion) return;
    this.ignorerProchaineRecherche = true;
    this.address = suggestion.display_name;
    this.latitude = parseFloat(suggestion.lat);
    this.longitude = parseFloat(suggestion.lon);
    this.sharedUtilsService.suggestions = [];
    this.adressSelected = true;
    this.closeDialogue();
  }


  
  onAddressInputChange(value: string) {
    this.address = value;
    if (this.ignorerProchaineRecherche) {
      this.ignorerProchaineRecherche = false;
      return;
    }
    this.adressSelected = false;
    this.sharedUtilsService.rechercheSubject.next(value);
  }

calculDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 6371;
  const dLat = this.toRad(lat2 - lat1);
  const dLon = this.toRad(lon2 - lon1);

  const a = Math.sin(dLat / 2) ** 2 +
            Math.cos(this.toRad(lat1)) * Math.cos(this.toRad(lat2)) *
            Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return Math.round(distance * 100) / 100;
}


toRad(deg: number): number {
  return deg * Math.PI / 180;
}

closeDialogue(){
    const latitudeValide = Number.isFinite(this.latitude);
    const longitudeValide = Number.isFinite(this.longitude);
    if (!this.address || !latitudeValide || !longitudeValide) return;
    this.dialogRef.close({
    latitude: this.latitude,
    longitude: this.longitude,
    address: this.address
  });
}

}
